import { createAsyncThunk } from '@reduxjs/toolkit';
import { getEvents as getEventsApi } from 'util/Api/events';

export const getEvents = createAsyncThunk(
  'events/getEvents',
  async ({ filters }, { rejectWithValue }) => {
    try {
      return await getEventsApi({ filters });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
